
import React from "react";
import { FormLabel, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { AlertCircle } from "lucide-react";

interface MediaUploadSectionProps {
  isDisabled: boolean;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  imageError: string | null;
  fileName: string | null;
  imagePreview: string | null;
  useDefaultBanner: boolean;
  onUseDefaultBannerChange: (checked: boolean) => void;
}

const MediaUploadSection = ({
  isDisabled,
  handleImageChange,
  imageError,
  fileName,
  imagePreview,
  useDefaultBanner,
  onUseDefaultBannerChange
}: MediaUploadSectionProps) => {
  return (
    <div className="space-y-4 pt-4">
      <h2 className="public-card-title">Image Upload</h2>

      <div className="flex items-center space-x-2">
        <Checkbox 
          id="useDefaultBanner"
          checked={useDefaultBanner}
          onCheckedChange={onUseDefaultBannerChange}
          disabled={isDisabled}
        />
        <FormLabel htmlFor="useDefaultBanner" className="text-sm font-normal cursor-pointer">
          Use default listing banner
        </FormLabel>
      </div>

      {!useDefaultBanner && (
        <div>
          <FormLabel>Service Image*</FormLabel>
          <Input 
            type="file" 
            accept="image/*" 
            onChange={handleImageChange} 
            disabled={isDisabled} 
            className="cursor-pointer" 
          />
          <FormDescription>
            Upload a cover image for your service listing
          </FormDescription>
          {imageError && (
            <div className="mt-1 flex items-start text-sm text-coral">
              <AlertCircle className="h-4 w-4 mr-1 mt-0.5 flex-shrink-0" />
              <p>{imageError}</p>
            </div>
          )}
          {fileName && <p className="mt-1 public-small">Selected: {fileName}</p>}

          {imagePreview && (
            <div className="mt-2">
              <img src={imagePreview} alt="Service Preview" className="max-h-40 rounded-md" loading="lazy" decoding="async" />
            </div>
          )}
        </div>
      )}

      {useDefaultBanner && (
        <div className="mt-2">
          <p className="mb-2 public-small">Using default listing banner:</p>
          <img src="/default-banner.png" alt="Default Banner Preview" className="max-h-40 rounded-md" loading="lazy" decoding="async" />
        </div>
      )}
    </div>
  );
};

export default MediaUploadSection;
